import {useState, useEffect} from 'react'
import data from './pt.json'
import './App.css';
import { AtomBlock } from './AtomBlock';

let p1 = [];let p2 = [];let p3 = [];let p4 = [];let p5 = [];let p6 = [];let p7 = [];
let lan=[]; let act=[];
let column=[];

function App() {
  const [Period1, setPeriod1] = useState([]);
  const [Period2, setPeriod2] = useState([]);
  const [Period3, setPeriod3] = useState([]);
  const [Period4, setPeriod4] = useState([]);
  const [Period5, setPeriod5] = useState([]);
  const [Period6, setPeriod6] = useState([]);
  const [Period7, setPeriod7] = useState([]);
  const [Lanthanide, setLanthanide] = useState([]);
  const [Actinide, setActinide] = useState([]);

  useEffect(()=>{
    for(let index = 0; index< data.length; index++) {
      if(index <=1) {
        p1.push(data[index])
        setPeriod1(p1);
      }
      if(index>=2 && index <=9){
        p2.push(data[index])
        setPeriod2(p2);
      }
      if(index>=10 && index <=17){
        p3.push(data[index])
        setPeriod3(p3);
      }
      if(index>=18 && index <=35){
        p4.push(data[index])
        setPeriod4(p4);
      }
      
      if(index>=36 && index <=53){
        p5.push(data[index])
        setPeriod5(p5);
      }
      
      if(index>=54 && index<=56 || index>=71 && index <=85){
        p6.push(data[index])
        setPeriod6(p6);
      }
      if(index>=86 && index<=88 || index>=103 && index <=117){
        p7.push(data[index])
        setPeriod7(p7);
      }
      if(index>=56 && index<=72){
        lan.push(data[index])
        setLanthanide(lan)
      }
      if(index>=88 && index<=104){
        act.push(data[index])
        setActinide(act)
      }
    }
    
  },[])

    function ColSpan({spanNum}){
      return <td className="blank" colSpan={spanNum}> </td>
    }

    const BlankCol=({min,max})=>{ for (var x = min; x <= max; x++){
      column.push(<td key={`key.${x+Math.random()}`} className="GNum">{x}</td>)
      }
      return column}
  
      
  return (
   <>
   {!data && (<h3>Loading Please Wait...</h3>)}
   <table>
    <caption style={{textAlign:'center', color: 'white'}}><h1>PEORIDIC TABLE</h1></caption>
     <tbody><tr>
     <td className="GNum">1</td><ColSpan spanNum={'16'}/><td className="GNum">18</td>
     </tr>
     <tr tiltle="Period 1">
     {Period1.map((newData,i)=>{
      if(i===0) return <>
      <td className={`element ${newData.groupBlock}`} key={`Period_1_${i+1}`}>
      <AtomBlock key={`1.${i}`} newData={newData}/>
        </td>
        <td className="GNum">2</td><ColSpan spanNum={'10'}/>
        <BlankCol min={13} max={17} />
        </>
     return (<td className={`element ${newData.groupBlock}`} key={`Period_1_${i+10}`}>
       <AtomBlock key={`2.${i}`} newData={newData}/>
     </td>)
   })}</tr>
     <tr tiltle="Period 2">
     {Period2.map((newData,i)=>{
      if(i===1) return <>
      <td className={`element ${newData.groupBlock}`} key={`period_2_${i+20}`}>
      <AtomBlock key={`3.${i}`} newData={newData}/>
        </td>
        <ColSpan spanNum={'10'}/>
        </>
     return <td className={`element ${newData.groupBlock}`} key={`Period_2${i+50}`}>
       <AtomBlock key={`4.${i}`} newData={newData}/>
       </td>
   })}</tr>
     <tr tiltle="Period 3">
     {Period3.map((newData,i)=>{
      if(i===1) return <>
      <td className={`element ${newData.groupBlock}`} key={`Period_3.1_${i+100}`}>
      <AtomBlock key={`5.${i}`} newData={newData}/>
        </td><BlankCol2/>
        </>
     return <td className={`element ${newData.groupBlock}`} key={`Period_3_${i+1}`}>
       <AtomBlock key={`6.${i}`} newData={newData}/>
       </td>
   })}</tr>
     <tr tiltle="Period 4">
     {Period4.map((newData,i)=>{
     return <td className={`element ${newData.groupBlock}`} key={`Period_4_${i+1}`}>
       <AtomBlock key={`7.${i}`} newData={newData}/>
       </td>
   })}</tr>
     <tr tiltle="Period 5">
     {Period5.map((newData,i)=>{
     return <td className={`element ${newData.groupBlock}`} key={`Period_5_${i+1}`}>
       <AtomBlock key={`8.${i}`} newData={newData}/>
       </td>
   })}</tr>
     <tr tiltle="Period 6">
     {Period6.map((newData,i)=>{
     return <td className={`element ${newData.groupBlock}`} key={`Period_6_${i+1}`}>
       <AtomBlock key={`9.${i}`} newData={newData}/>
     </td>
   })}</tr>
       <tr tiltle="Period 7">
     {Period7.map((newData,i)=>{
     return <td className={`element ${newData.groupBlock}`} key={`Period_7_${i+1}`}>
      <AtomBlock key={`0.${i}`} newData={newData}/>
       </td>
   })}</tr>
   </tbody>
   </table>
   <br/>
   <table>
     <tbody>
       <tr><td className="lan-ser element">Lanthanide Series</td>
       {Lanthanide.map((newData,i)=>{
          return <td className={`element ${newData.groupBlock}`} key={`Lanthanide_${i+1}`}>
            <AtomBlock key={`lan.${i}`} newData={newData}/>
          </td>
        })}
       </tr>
       <tr><td className="element act-ser">Actinide Series</td>
       {Actinide.map((newData,i)=>{
          return <td className={`element ${newData.groupBlock}`} key={`Actinide_${i+1}`}>
            <AtomBlock key={`act.${i}`} newData={newData}/>
          </td>
        })}
       </tr>
     </tbody>
   </table>
   <br/>
        <table style={{textAlign: 'center', margin: '0 auto', paddingBottom: '220px'}}><tbody><tr>
          <td className='nonmetal colorChart'>Non<br/>Metal</td>
          <td className='metalloid colorChart'>Metalloid</td>
          <td className='alkaline colorChart'>Alkaline<br/>Earth</td>
          <td className='alkali colorChart'>Alkali<br/>Metal</td>
          <td className='noble colorChart'>Noble<br/>Gas</td>
          <td className='transition colorChart'>Transition<br/>Metal</td>
          <td className='halogen colorChart'>Halogen</td>
          <td className='halogen colorChart'>Halogen</td>
          <td className='post-transition colorChart'>Post Transition<br/>Metal</td>
          <td className='lanthanoid colorChart'>Lanthanoid</td>
          <td className='actinoid colorChart'>Actinoid</td>
          </tr></tbody></table>
        <span id="datacredit" className="white-txt">periodic table dataset was collected from https://neelpatel05.pythonanywhere.com/</span>
        <span className="copyright white-txt">Developed by Khandakar Shakib</span>
   </>
  );
}

export default App;


const BlankCol2=()=>{
  return (<>
  <td className="GNum">3</td>
  <td className="GNum">4</td><td className="GNum">5</td>
  <td className="GNum">6</td><td className="GNum">7</td>
  <td className="GNum">8</td><td className="GNum">9</td>
  <td className="GNum">10</td><td className="GNum">11</td>
  <td className="GNum">12</td>
  </>)
}